import { render, staticRenderFns } from "./ObjectionBulkUpdater.vue?vue&type=template&id=40da63ad&scoped=true"
import script from "./ObjectionBulkUpdater.vue?vue&type=script&lang=ts"
export * from "./ObjectionBulkUpdater.vue?vue&type=script&lang=ts"
import style0 from "./ObjectionBulkUpdater.vue?vue&type=style&index=0&id=40da63ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da63ad",
  null
  
)

export default component.exports